
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting Institution errors, which are returned when issues arise with the requested financial institution.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Institution errors' subtitle='Guide to troubleshooting Institution errors' mdxType="Header" />
    <h4 {...{
      "id": "institution_down"
    }}><strong parentName="h4">{`INSTITUTION_DOWN`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='INSTITUTION_DOWN' subtitle="The financial institution is down, either for maintenance or due to an infrastructure issue with their systems." server client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience"
      }}>{`Link user experience`}</h5>
      <p>{`Your user will be redirected to the `}<inlineCode parentName="p">{`Institution Select`}</inlineCode>{` pane to retry connecting their Item or a different account.`}</p>
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The institution is undergoing scheduled maintenance.`}</li>
        <li parentName="ul">{`The institution is experiencing temporary technical problems.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INSTITUTION_DOWN-1' mdxType="Checkbox">
        <p>{`Prompt your user to retry connecting their Item in a few hours, or the following day.`}</p>
      </Checkbox>
      <Checkbox checklistId='INSTITUTION_DOWN-2' mdxType="Checkbox">
        <p>{`Check the status of the institution via the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/activity/status"
          }}>{`Dashboard`}</a>{` or `}<inlineCode parentName="p">{`/institutions/get_by_id`}</inlineCode>{`.`}</p>
      </Checkbox>
      <p>{`If the error persists, please submit a 'Persistent institution or server errors' `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/financial-institutions/authentication-issues/persistent-500"
        }}>{`Support`}</a>{` ticket with the following identifiers: `}<inlineCode parentName="p">{`access_token`}</inlineCode>{`, `}<inlineCode parentName="p">{`institution_id`}</inlineCode>{`, and either `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` or `}<inlineCode parentName="p">{`request_id`}</inlineCode>{`.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "institution_not_enabled_in_environment"
    }}><strong parentName="h4">{`INSTITUTION_NOT_ENABLED_IN_ENVIRONMENT`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='INSTITUTION_NOT_ENABLED_IN_ENVIRONMENT' subtitle="Institution not enabled in this environment" server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <p>{`You're referencing an institution that exists, but is not enabled for this environment (e.g. calling a Sandbox endpoint with the ID of an institution that is not enabled there).`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "institution_not_responding"
    }}><strong parentName="h4">{`INSTITUTION_NOT_RESPONDING`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='INSTITUTION_NOT_RESPONDING' subtitle="The financial institution is failing to respond to some of our requests. Your user may be successful if they retry another time." server client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience-1"
      }}>{`Link user experience`}</h5>
      <p>{`Your user will be redirected to the `}<inlineCode parentName="p">{`Institution Select`}</inlineCode>{` pane to retry connecting their Item or a different account.`}</p>
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The institution is experiencing temporary technical problems.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INSTITUTION_NOT_RESPONDING-1' mdxType="Checkbox">
        <p>{`Prompt your user to retry connecting their Item in a few hours, or the following day.`}</p>
      </Checkbox>
      <Checkbox checklistId='INSTITUTION_NOT_RESPONDING-2' mdxType="Checkbox">
        <p>{`Check the status of the institution via the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/activity/status"
          }}>{`Dashboard`}</a>{` or `}<a parentName="p" {...{
            "href": "/docs/api/institutions"
          }}>{`Institutions API`}</a>{`.`}</p>
      </Checkbox>
      <p>{`If the error persists, please submit a 'Persistent institution or server errors' `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/financial-institutions/authentication-issues/persistent-500"
        }}>{`Support`}</a>{` ticket with the following identifiers: `}<inlineCode parentName="p">{`access_token`}</inlineCode>{`, `}<inlineCode parentName="p">{`institution_id`}</inlineCode>{`, and either `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` or `}<inlineCode parentName="p">{`request_id`}</inlineCode>{`.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "institution_not_available"
    }}><strong parentName="h4">{`INSTITUTION_NOT_AVAILABLE`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='INSTITUTION_NOT_AVAILABLE' subtitle="The financial institution is not available at this time." server client mdxType="ErrorReference">
      <h5 {...{
        "id": "link-user-experience-2"
      }}>{`Link user experience`}</h5>
      <p>{`Your user will be redirected to the `}<inlineCode parentName="p">{`Institution Select`}</inlineCode>{` pane to retry connecting their Item or a different account.`}</p>
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid's connection to an institution is temporarily down for maintenance or other planned circumstances.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INSTITUTION_NOT_AVAILABLE-1' mdxType="Checkbox">
        <p>{`Prompt your user to retry connecting their Item in a few hours or the following day.`}</p>
      </Checkbox>
      <Checkbox checklistId='INSTITUTION_NOT_AVAILABLE-2' mdxType="Checkbox">
        <p>{`Check the status of the institution via the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/activity/status"
          }}>{`Dashboard`}</a>{` or `}<a parentName="p" {...{
            "href": "/docs/api/institutions/"
          }}>{`API`}</a>{`.`}</p>
      </Checkbox>
      <p>{`If the error persists, please submit a 'Persistent institution or server errors' `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/financial-institutions/authentication-issues/persistent-500"
        }}>{`Support`}</a>{` ticket with the following identifiers: `}<inlineCode parentName="p">{`access_token`}</inlineCode>{`, `}<inlineCode parentName="p">{`institution_id`}</inlineCode>{`, and either `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` or `}<inlineCode parentName="p">{`request_id`}</inlineCode>{`.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "institution_no_longer_supported"
    }}><strong parentName="h4">{`INSTITUTION_NO_LONGER_SUPPORTED`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='INSTITUTION_NO_LONGER_SUPPORTED' subtitle="Plaid no longer supports this financial institution." server client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The financial institution is no longer supported on Plaid's platform.`}</li>
        <li parentName="ul">{`The institution has switched from supporting non-OAuth-based connections to requiring OAuth-based connections.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`This error is un-retryable and requires custom updates from Plaid to resolve. Submit a `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/support/new/financial-institutions"
          }}>{`Support`}</a>{` ticket with the failing `}<inlineCode parentName="p">{`institution_id`}</inlineCode>{` for more detailed information.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "unauthorized_institution"
    }}><strong parentName="h4">{`UNAUTHORIZED_INSTITUTION`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='UNAUTHORIZED_INSTITUTION' subtitle='You are not authorized to create Items for this institution at this time.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Access to this institution is subject to additional verification and must be manually enabled for your account.`}</li>
        <li parentName="ul">{`You have not yet completed the OAuth registration requirements for the institution.`}</li>
        <li parentName="ul">{`The institution is experiencing a temporary outage. `}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='UNAUTHORIZED_INSTITUTION-1' mdxType="Checkbox">
        <p>{`Make sure your account is enabled for Production access.`}</p>
      </Checkbox>
      <Checkbox checklistId='UNAUTHORIZED_INSTITUTION-2' mdxType="Checkbox">
        <p>{`See the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/settings/compliance/us-oauth-institutions"
          }}>{`OAuth institutions`}</a>{` page in the Dashboard for a list of incomplete OAuth registration requirements.`}</p>
      </Checkbox>
      <Checkbox checklistId='UNAUTHORIZED_INSTITUTION-3' mdxType="Checkbox">
        <p>{`If there are no incomplete OAuth registration requirements displayed for this institution in the Dashboard, or if you still cannot access the institution 24 hours after completing the registration requirements, contact your Plaid account manager or `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/support"
          }}>{`Plaid support`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "institution_registration_required"
    }}><strong parentName="h4">{`INSTITUTION_REGISTRATION_REQUIRED`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='INSTITUTION_REGISTRATION_REQUIRED' subtitle='Your application is not yet registered with the institution.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`If your account was recently enabled for full Production access or a Trial plan, it may take up to 1-2 days to get access to certain institutions.`}</li>
        <li parentName="ul">{`Details about your application must be registered with this institution before use.`}</li>
        <li parentName="ul">{`You have not completed the Security Questionnaire.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INSTITUTION_REGISTRATION_REQUIRED-1' mdxType="Checkbox">
        <p>{`If your account was recently enabled for Production or a Trial plan or you recently completed the Security Questionnaire, it may take up to 1-2 days for registration to be completed with the institution. For Charles Schwab, registration may take up to 5 business days. `}</p>
      </Checkbox>
      <Checkbox checklistId='INSTITUTION_REGISTRATION_REQUIRED-0' mdxType="Checkbox">
        <p>{`If you are on a paid (non-Trial) plan, make sure to complete the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/overview/questionnaire"
          }}>{`Security Questionnaire`}</a>{`.`}</p>
      </Checkbox>
      <Checkbox checklistId='INSTITUTION_REGISTRATION_REQUIRED-2' mdxType="Checkbox">
        <p>{`If you are still unable to access the institution after completing the above steps and waiting the appropriate time, please `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/support"
          }}>{`contact support`}</a>{` regarding the status of your registration.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "unsupported_response"
    }}><strong parentName="h4">{`UNSUPPORTED_RESPONSE`}</strong></h4>
    <ErrorReference type='INSTITUTION_ERROR' error='UNSUPPORTED_RESPONSE' subtitle="The data returned from the financial institution is not valid." server client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-7"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The data returned from the financial institution is not supported or is invalid.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-6"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`This error is un-retryable and requires custom updates from Plaid to resolve. Submit a `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/support/new/financial-institutions"
          }}>{`Support`}</a>{` ticket with the failing `}<inlineCode parentName="p">{`institution_id`}</inlineCode>{` for more detailed information.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "institution_down",
        level: 4,
        title: "INSTITUTION_DOWN",
      },
{
        id: "institution_not_enabled_in_environment",
        level: 4,
        title: "INSTITUTION_NOT_ENABLED_IN_ENVIRONMENT",
      },
{
        id: "institution_not_responding",
        level: 4,
        title: "INSTITUTION_NOT_RESPONDING",
      },
{
        id: "institution_not_available",
        level: 4,
        title: "INSTITUTION_NOT_AVAILABLE",
      },
{
        id: "institution_no_longer_supported",
        level: 4,
        title: "INSTITUTION_NO_LONGER_SUPPORTED",
      },
{
        id: "unauthorized_institution",
        level: 4,
        title: "UNAUTHORIZED_INSTITUTION",
      },
{
        id: "institution_registration_required",
        level: 4,
        title: "INSTITUTION_REGISTRATION_REQUIRED",
      },
{
        id: "unsupported_response",
        level: 4,
        title: "UNSUPPORTED_RESPONSE",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
